module.exports = __webpack_public_path__ + "img/codeigniter-development.001f5c3c.webp";